export const slickSliderArticleSettings = {
    speed: 500,
    centerMode: false,
    infinite: false,
    outerEdgeLimit: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    variableWidth: true,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                variableWidth: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: true
            }
        },
        {
            breakpoint: 768,
            settings: {
                variableWidth: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                infinite: false
            }
        },
        {
            breakpoint: 440,
            settings: {
                variableWidth: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true
            }
        }
    ]
};
export const slickSliderArticleSettings = {
    speed: 500,
    centerMode: false,
    infinite: false,
    outerEdgeLimit: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    variableWidth: true,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                variableWidth: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: true
            }
        },
        {
            breakpoint: 768,
            settings: {
                variableWidth: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                infinite: false
            }
        },
        {
            breakpoint: 440,
            settings: {
                variableWidth: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true
            }
        }
    ]
};
